import { MessageBox } from 'element-ui'
export const crudOptions = {
  addTitle: 'Add',
  editTitle: 'Edit',
  viewTitle: 'View',
  options: {
    height: '100%',
    stripe: true
  },
  viewOptions: {
    disabled: false
  },
  pageOptions: {
    compact: false
  },
  formOptions: {
    type: 'dialog',
    saveRemind: function saveReminder() {
      return MessageBox.confirm('Unsaved content detected, do you want to save changes before leaving the page?', 'Confirmation message', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Discard',
        type: 'warning'
      })
    },
    saveLoading: false,
    saveButtonType: 'primary',
    saveButtonText: 'Confirm',
  },
  rowHandle: {
    columnHeader: 'Operations',
    view: {
      text: 'view'
    },
    edit: {
      thin: true,
      type: 'primary',
      text: 'edit'
    },
    remove: {
      thin: true,
      text: 'delete',
      confirmTitle: 'Delete',
      confirmText: 'Are you sure you want to delete?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    },
    width: 280
  },
  columns: [
    {
      title: 'ID',
      key: 'id',
      width: 70,
      form: {
        disabled: true
      }
    },
    {
      title: 'name',
      key: 'name',
      search: { disabled: false },
      sortable: true,
      form: {
        rules: [{ required: true, message: 'Please input the name of the operator' }],
        component: {
          name: 'el-input',
          props: {
            type: 'text',
          }
        }
      }
    },
    {
      title: 'source',
      key: 'source',
      sortable: true,
      form: {
        rules: [{ required: true, message: 'Please input the source of the operator' }],
        component: {
          name: 'el-input',
          props: {
            type: 'text',
          }
        }
      }
    },
    {
      title: 'alias',
      key: 'alias',
      sortable: true,
      form: {
        // for customizing the panel
        slot: true
      }
    },
    {
      title: 'type',
      key: 'type',
      type: 'select',
      dict: {
        data: [{ value: 'unary', label: 'unary' }, { value: 'binary', label: 'binary' }]
      },
      form: {
        rules: [{ required: true, message: 'Please select the type of the operator' }],
      }
    },
    {
      title: 'definition',
      key: 'definition',
      type: 'text-area',
      showOverflowTooltip: true,
      sortable: true
    },
    {
      title: 'description',
      key: 'description',
      sortable: true,
      type: 'text-area',
      showOverflowTooltip: true,
      form: {
        rules: [{ required: true, message: 'Please input the description of the operator' }],
        slot: true,
        component: {
          name: 'el-input',
          props: {
            type: 'text',
          }
        }
      }
    },
    {
      title: 'condition',
      key: 'condition',
      type: 'select',
      form: {
        rules: [{ required: true, message: 'Please select whether the operator has conditions' }],
      },
      dict: {
        data: [{ value: true, label: "True" }, { value: false, label: "False" }]
      }
    },
    {
      title: 'target',
      // width: 150,
      key: 'target',
      form: {
        slot: true
      }
    }
  ],
  pagination: {
    pageSize: 20
  }
}
